import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {KindOfOrder} from '../../../../types/enums';
import {FileType} from '../types/FileType'

export const useGetFileTypes = (kindOfOrder: KindOfOrder, orderTypeID: number | undefined, enabled: boolean) => {

    const { data, isLoading } = useQuery({
        queryKey: ['file-types', kindOfOrder, orderTypeID],
        queryFn: async () => await apiClient.get('document/file-types',
            { params: { kindOfOrder: kindOfOrder, orderTypeID: orderTypeID } }) as FileType[],
        enabled: enabled
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
